export default __webpack_public_path__ + "static/media/sportsman_01.2ef7ca74.jpeg";